module.exports = __webpack_public_path__ + "3b4e0edecab66696957577850a95823a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/oakmark.png
// module id = 1832
// module chunks = 0